/* Карточка коммутатора — панель справа: таблица объекта остаётся
   видна слева, по ней можно сверяться. */

.overlay {
  position: fixed;
  inset: 0;
  z-index: 300;
  background: var(--scrim);
  border: none;
}

.card {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 301;
  display: flex;
  flex-direction: column;
  width: 560px;
  max-width: 100vw;
  overflow: hidden;
  background: var(--card-bg);
  border-left: 1px solid var(--border);
  box-shadow: -16px 0 40px rgba(15, 23, 42, .16);
  animation: slideIn .2s ease-out;
}

@keyframes slideIn {
  from { transform: translateX(24px); opacity: 0; }
  to { transform: none; opacity: 1; }
}

.header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-shrink: 0;
  padding: 22px 24px 16px;
  border-bottom: 1px solid var(--border);
}

.name {
  font-family: var(--mono);
  font-size: 19px;
  font-weight: 600;
  color: var(--text);
}

.object { margin-top: 2px; font-size: 13.5px; color: var(--text2); }
.spacer { flex: 1; }

.close {
  width: 34px;
  height: 34px;
  padding: 0;
  font-size: 22px;
  line-height: 1;
  color: var(--text2);
  background: none;
  border: 1px solid transparent;
  border-radius: var(--r-sm);
  cursor: pointer;
}

.close:hover { color: var(--text); border-color: var(--border); }

.body { flex: 1; padding: 8px 24px 24px; overflow-y: auto; }

.section { padding-top: 16px; }
.section + .section { margin-top: 8px; border-top: 1px solid var(--border); }

.sectionTitle {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

.field {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  min-height: 38px;
  padding: 4px 0;
}

.fieldLabel { font-size: 13px; color: var(--text2); }
.fieldValue { font-size: 14px; color: var(--text); overflow-wrap: anywhere; }
.fieldValue.mono { font-family: var(--mono); font-size: 13px; }
.fieldValue.missing { color: var(--err); }

.input {
  height: 34px;
  padding: 0 10px;
  font-size: 14px;
  color: var(--text);
  background: var(--input-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
}

.input:focus { outline: none; border-color: var(--blue); }

.copyBtn {
  height: 30px;
  padding: 0 8px;
  font-size: 13px;
  color: var(--text2);
  background: none;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  cursor: pointer;
}

.copyBtn:hover { color: var(--blue); border-color: var(--blue); }
.copyBtn.ok { color: var(--ok); border-color: var(--ok); }

.note {
  width: 100%;
  min-height: 80px;
  padding: 9px 11px;
  font-family: var(--sans);
  font-size: 14px;
  color: var(--text);
  background: var(--input-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  resize: vertical;
}

.note:focus { outline: none; border-color: var(--blue); }

.meta { margin-top: 6px; font-size: 12.5px; color: var(--text2); }

.location {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: var(--text);
}

.footer {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  gap: 8px;
  padding: 14px 24px;
  border-top: 1px solid var(--border);
}

.button {
  height: 36px;
  padding: 0 14px;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text);
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  cursor: pointer;
}

.button:hover { border-color: var(--slate-lt); }

.primary {
  color: #fff;
  background: var(--blue);
  border-color: var(--blue);
}

.primary:hover { background: var(--blue-dark); border-color: var(--blue-dark); }

.danger {
  color: var(--action-danger);
  background: var(--card-bg);
  border-color: color-mix(in srgb, var(--action-danger) 40%, transparent);
}

.danger:hover { color: #fff; background: var(--action-danger); border-color: var(--action-danger); }

:global(html.dark) .danger { color: var(--err); }
:global(html.dark) .danger:hover { color: #fff; }

.error {
  margin-top: 12px;
  padding: 10px 12px;
  font-size: 13px;
  color: var(--err);
  background: var(--err-bg);
  border-radius: var(--r-sm);
}

@media (max-width: 699px) {
  .card { width: 100%; border-left: none; }
  .header { padding: 16px; }
  .body { padding: 4px 16px 20px; }
  .footer { padding: 12px 16px; }
  .field { grid-template-columns: 112px minmax(0, 1fr) auto; gap: 8px; }
}

/* Без кнопки справа поле занимает всю ширину */
.field > .input:last-child,
.field > .fieldValue:last-child { grid-column: 2 / -1; }
